import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { Grid, Box, Button, Typography, Link } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { setCookie } from 'util/icwUtility';

const styles = (theme) => ({
  container: {
    position: 'relative',
    top: 0,
    backgroundColor: '#F6F6F6',
    padding: theme.spacing(4),
  },
  button: {
    textAlign: 'center',
  },
  text: {
    fontWeight: 400,
  },
});

const Announcement = (props) => {
  const { classes } = props;

  const [open, setOpen] = useState(true);

  const renderContent = () => {
    return (
      <Box>
        <Typography variant='h6'>{T.translate('login.announcement.title')}</Typography>
        <Typography variant='body2' className={classes.text}>
          {T.translate('login.announcement.content01')}&nbsp;
          <Link href='http://qmas.icw.io' target='_blank' rel='noopener noreferrer'>
            qmas.icw.io
          </Link>
          &nbsp;{T.translate('login.announcement.content02')}
          &nbsp;&&nbsp;
          <Link href='http://www.icwcn.net' target='_blank' rel='noopener noreferrer'>
            www.icwcn.net
          </Link>
          &nbsp;{T.translate('login.announcement.content03')}
          &nbsp;{T.translate('login.announcement.content04')}.
        </Typography>
        <Typography variant='body2' className={classes.text}>
          {T.translate('login.announcement.content05')}&nbsp;
          <Link href='tel:+85237050346' target='_blank' rel='noopener noreferrer'>
            (+852) 3705-0346
          </Link>
          &nbsp;{T.translate('login.announcement.content06')}&nbsp;
          <Link href='mailto:info@icw.io' target='_blank' rel='noopener noreferrer'>
            info@icw.io
          </Link>
        </Typography>
        <Typography variant='body2' className={classes.text}>
          {T.translate('login.announcement.content07')}&nbsp;
          <Link
            href='https://qmas.icw.io/blog/2020/02/14/alert-on-fraudulent-website'
            target='_blank'
            rel='noopener noreferrer'>
            {T.translate('login.announcement.content08')}
          </Link>
          &nbsp;{T.translate('login.announcement.content09')}.
        </Typography>
      </Box>
    );
  };

  const renderButton = () => (
    <Button
      variant='outlined'
      color='primary'
      onClick={() => {
        setOpen(false);
        setCookie('qmas_important_notice', false);
      }}>
      {T.translate('login.announcement.understand')}
    </Button>
  );

  return open ? (
    <Grid container alignItems='center' className={classes.container}>
      <Grid item xs={12} sm={10} md={10} lg={10}>
        {renderContent()}
      </Grid>
      <Grid item xs={12} sm={2} md={2} lg={2} className={classes.button}>
        {renderButton()}
      </Grid>
    </Grid>
  ) : null;
};

Announcement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Announcement);
